/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsVulnerabilityFixAvailableDetails {
    getFixupPrototypeFunction() { return AppSecopsVulnerabilityFixAvailableDetails.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsVulnerabilityFixAvailableDetails>): AppSecopsVulnerabilityFixAvailableDetails {
        let obj = Object.assign(new AppSecopsVulnerabilityFixAvailableDetails(), model);
        AppSecopsVulnerabilityFixAvailableDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsVulnerabilityFixAvailableDetails>): AppSecopsVulnerabilityFixAvailableDetails {
        if (!model) return null;
        return AppSecopsVulnerabilityFixAvailableDetails.newInstance(<AppSecopsVulnerabilityFixAvailableDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsVulnerabilityFixAvailableDetails) {
        if (!obj) return;

        models.AppSecopsVulnerabilityFixAvailableDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsVulnerabilityFixAvailableDetails): boolean {
        Object.setPrototypeOf(obj, AppSecopsVulnerabilityFixAvailableDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Source of vulnerability
     */
    source: models.VulnerabilitySource;

    /**
     * List of component IDs that are affected by this vulnerability and for which a fix is available
     */
    affected_component_ids: Array<string>;

}
